module.exports = __webpack_public_path__ + "img/loadingGif.6cfe0fe1.gif";